export enum images {
  classic = '94eb32_85413688d0df401f988c6dacb5c7f0db~mv2.jpg',
  studio = '94eb32_e1eaa5343ec34f128bdf85f2a74699ea~mv2.png',
}
